import React, {useMemo} from "react";
import {Box, CircularProgress, Link, Typography} from "@mui/material";
import {DataGridPro, GridColDef} from "@mui/x-data-grid-pro";
import {datetimeFormat} from "../../lang/date-formats";
import {GridState} from "../../libs/grid_state_reducers";
import {RegFilters} from "./registrations/reg_grid_slice";
import {RegistrationApiGet, useGetRegListQuery} from "../registration/reg_api";
import SnackError from "../../components/SnackError";

type RegGridProps = {
    gridState: GridState & RegFilters,
    groupByFilter: Object
}

export default ({gridState, groupByFilter}: RegGridProps) => {
    const {data, isFetching, error} = useGetRegListQuery({...gridState, ...groupByFilter});

    const columns = useMemo<GridColDef<RegistrationApiGet>[]>(() => {
        return [
            {
                field: 'profile',
                headerName: 'Uporabnik',
                renderCell: (params) => {
                    return <Link href={`/reg/${params.row.id}`}>{params.row?.profile?.fullName}</Link>
                },
                width: 120
            },
            {
                field: 'StartTime',
                type: 'dateTime',
                valueGetter: (value) => value && new Date(value),
                headerName: 'Začetek',
                valueFormatter: (val?: Date) => val?.toLocaleString("sl", datetimeFormat),
                width: 150
            },
            {
                field: 'EndTime',
                valueGetter: (value) => value ? new Date(value) : undefined,
                valueFormatter: (val?: Date) => val?.toLocaleString("sl", datetimeFormat) ?? "",
                type: 'dateTime',
                headerName: 'Konec',
                width: 150
            },
            {
                field: 'WorkOrder',
                valueGetter: (value, row) => row.workOrder?.number,
                headerName: 'DN',
                width: 75
            },
            {
                field: 'buyer',
                valueGetter: (value, row) => row.workOrder?.buyerName,
                headerName: 'Kupec',
                width: 150
            },
            {
                field: 'product',
                valueGetter: (value, row) => row.product?.Name,
                headerName: 'Artikel',
                width: 150
            },
            {
                field: 'productCode',
                valueGetter: (value, row) => row.product?.Code,
                headerName: 'Šifra',
                width: 75
            },
            {
                field: "operation",
                valueGetter: (value, row) => row.workTask?.Name,
                headerName: 'Operacija',
                width: 100
            },

            {
                field: "worker",
                valueGetter: (value, row) => row.worker?.lastName + " " + row.worker?.firstName,
                headerName: 'Delavec',
                width: 100
            },
            {
                field: "machine",
                valueGetter: (value, row) => row.machine?.Name,
                headerName: 'Stroj',
                width: 100
            },
            {
                field: "ElapsedTime",
                valueFormatter: (val) => {
                    const hours = Math.trunc(val / 3600);
                    const minutes = Math.round((val - hours * 3600) / 60);
                    return hours + ":" + (`0${minutes}`).slice(-2)
                },
                headerName: 'Čas',
                width: 50
            }
        ];
    }, []);

    if (isFetching) return <CircularProgress/>

    if (!data || data.count == 0) return <Box sx={{p: "1em"}}><Typography>Ni registracij</Typography></Box>

    console.log(data)
    return <Box sx={{p: "1em"}}>
        {error && <SnackError error={error}/>}
        <DataGridPro
            columns={columns}
            density={"compact"}
            filterMode="server"
            loading={isFetching}
            rows={data?.result || []}
        />
    </Box>;
}
